import {
  REQUEST_ANTI_FORGERY,
  REQUEST_ANTI_FORGERY_SUCCESS,
  REQUEST_ANTI_FORGERY_FAILURE,
  REQUEST_LINKS,
  REQUEST_LINKS_SUCCESS,
  REQUEST_LINKS_FAILURE,
  REQUEST_FEATURE_TOGGLES,
  REQUEST_FEATURE_TOGGLES_SUCCESS,
  REQUEST_FEATURE_TOGGLES_FAILURE,
  CREATE_QUOTE,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILURE,
  REQUEST_PRICE,
  REQUEST_PRICE_SUCCESS,
  REQUEST_PRICE_FAILURE,
  SELECT_PRICE,
  UPDATE_STEP,
  REQUEST_QUOTE,
  REQUEST_QUOTE_SUCCESS,
  REQUEST_QUOTE_FAILURE,
  IS_LOADING,
  REQUEST_AFFILIATE,
  REQUEST_AFFILIATE_SUCCESS,
  REQUEST_AFFILIATE_FAILURE,
  SET_UNDERWRITER_CHANGED,
  SET_QUERY_STRING,
  REQUEST_OPEN_SCHEMES,
  REQUEST_OPEN_SCHEMES_SUCCESS,
  REQUEST_OPEN_SCHEMES_FAILURE,
  GET_QUOTE_SUMMARY_SUCCESS,
  SET_UI_ELEMENT_VISIBILITY,
  SET_UI_ELEMENT_MESSAGE_VISIBILITY,
  SET_TEMP_UNDERWRITER,
  UPDATE_CAMPAIGN_DATA,
  CREATE_CLIENT_SESSION,
  UPDATE_CLIENT_SESSION_QUOTE,
  SET_CLIENT_SESSION_GUID,
  SET_CLIENT_SESSION_QUOTE,
  SET_CLIENT_SESSION_DATA,
  SET_CLIENT_SESSION_STATE,
  SET_CLIENT_SESSION_LAST_ACTIVITY,
  GET_APP_STARTUP,
  GET_APP_STARTUP_SUCCESS,
  GET_APP_STARTUP_FAILURE,
  SET_QUOTE_JOURNEY_POSITION,
  REQUEST_CONFUSED_QUICK_QUOTE,
  REQUEST_CONFUSED_QUICK_QUOTE_SUCCESS,
  REQUEST_CONFUSED_QUICK_QUOTE_FAILURE,
  REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE,
  REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE_SUCCESS,
  REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE_FAILURE,
  REQUEST_CONFUSED_EXTERNAL_ACCOUNT,
  REQUEST_CONFUSED_EXTERNAL_ACCOUNT_SUCCESS,
  REQUEST_CONFUSED_EXTERNAL_ACCOUNT_FAILURE,
  RENDER_READY,
  UPDATE_CONFUSED_EXTERNAL_ACCOUNT,
} from './constants'

export function isLoading(isLoading) {
  return {
    type: IS_LOADING,
    isLoading,
  }
}

export function requestAntiForgery() {
  return {
    type: REQUEST_ANTI_FORGERY,
  }
}

export function requestAntiForgerySuccess() {
  return {
    type: REQUEST_ANTI_FORGERY_SUCCESS,
  }
}

export function requestAntiForgeryFailure(message) {
  return {
    type: REQUEST_ANTI_FORGERY_FAILURE,
    message,
  }
}

export function requestLinks() {
  return {
    type: REQUEST_LINKS,
  }
}

export function requestLinksSuccess(links) {
  return {
    type: REQUEST_LINKS_SUCCESS,
    links,
  }
}

export function requestLinksFailure(message) {
  return {
    type: REQUEST_LINKS_FAILURE,
    message,
  }
}

export function requestFeatureToggles() {
  return {
    type: REQUEST_FEATURE_TOGGLES,
  }
}

export function requestFeatureTogglesSuccess(featureToggles) {
  return {
    type: REQUEST_FEATURE_TOGGLES_SUCCESS,
    featureToggles,
  }
}

export function requestFeatureTogglesFailure(message) {
  return {
    type: REQUEST_FEATURE_TOGGLES_FAILURE,
    message,
  }
}

export function createQuote() {
  return {
    type: CREATE_QUOTE,
  }
}

export function createQuoteSuccess(quote, emailAddress) {
  return {
    type: CREATE_QUOTE_SUCCESS,
    quote,
    emailAddress,
  }
}

export function createQuoteFailure(message) {
  return {
    type: CREATE_QUOTE_FAILURE,
    message,
  }
}

export function requestPrice() {
  return {
    type: REQUEST_PRICE,
  }
}

export function requestPriceSuccess(price) {
  return {
    type: REQUEST_PRICE_SUCCESS,
    price,
  }
}

export function requestPriceFailure(message) {
  return {
    type: REQUEST_PRICE_FAILURE,
    message,
  }
}

export function selectPrice(price) {
  return {
    type: SELECT_PRICE,
    price,
  }
}

export function requestQuote(quoteId) {
  return {
    type: REQUEST_QUOTE,
    quoteId,
  }
}

export function requestQuoteSuccess(quote, scheme) {
  return {
    type: REQUEST_QUOTE_SUCCESS,
    quote,
    scheme,
  }
}

export function requestQuoteFailure(message) {
  return {
    type: REQUEST_QUOTE_FAILURE,
    message,
  }
}

export function updateStep(step) {
  return {
    type: UPDATE_STEP,
    step,
  }
}

export function requestAffiliate() {
  return {
    type: REQUEST_AFFILIATE,
  }
}

export function requestAffiliateSuccess(affiliate) {
  return {
    type: REQUEST_AFFILIATE_SUCCESS,
    affiliate,
  }
}

export function requestAffiliateFailure() {
  return {
    type: REQUEST_AFFILIATE_FAILURE,
  }
}

export function setQueryString(queryString) {
  return {
    type: SET_QUERY_STRING,
    queryString,
  }
}
export function requestOpenSchemes() {
  return {
    type: REQUEST_OPEN_SCHEMES,
  }
}

export function requestOpenSchemesSuccess(openSchemes) {
  return {
    type: REQUEST_OPEN_SCHEMES_SUCCESS,
    openSchemes,
  }
}

export function requestOpenSchemesFailure() {
  return {
    type: REQUEST_OPEN_SCHEMES_FAILURE,
  }
}

export function getQuoteSummarySuccess(quoteSummary) {
  return {
    type: GET_QUOTE_SUMMARY_SUCCESS,
    quoteSummary,
  }
}

export function setUiElementVisibility(element, visibility) {
  return {
    type: SET_UI_ELEMENT_VISIBILITY,
    element,
    visibility,
  }
}

export function setUiElementMessageVisibility(element, visibility) {
  return {
    type: SET_UI_ELEMENT_MESSAGE_VISIBILITY,
    element,
    visibility,
  }
}

export function setUnderwriterChanged() {
  return {
    type: SET_UNDERWRITER_CHANGED,
  }
}

export function setTempUnderwriter(underwriter) {
  return {
    type: SET_TEMP_UNDERWRITER,
    underwriter,
  }
}

export function updateCampaignData(campaignData) {
  return {
    type: UPDATE_CAMPAIGN_DATA,
    campaignData,
  }
}

export function getAppStartup() {
  return {
    type: GET_APP_STARTUP,
  }
}

export function getAppStartupSuccess() {
  return {
    type: GET_APP_STARTUP_SUCCESS,
  }
}

export function getAppStartupFailure() {
  return {
    type: GET_APP_STARTUP_FAILURE,
  }
}

export function renderReady() {
  return {
    type: RENDER_READY,
  }
}

export function createClientSession(sessionData) {
  return {
    type: CREATE_CLIENT_SESSION,
    sessionData,
  }
}

export function updateClientSessionQuote(sessionQuoteId) {
  return {
    type: UPDATE_CLIENT_SESSION_QUOTE,
    sessionQuoteId,
  }
}

export function setClientSessionQuote(sessionQuoteId) {
  return {
    type: SET_CLIENT_SESSION_QUOTE,
    sessionQuoteId,
  }
}

export function setClientSessionGuid(sessionGuid) {
  return {
    type: SET_CLIENT_SESSION_GUID,
    sessionGuid,
  }
}

export function setSessionBaseData(sessionBaseData) {
  return {
    type: SET_CLIENT_SESSION_DATA,
    sessionBaseData,
  }
}

export function setClientSessionState(sessionState) {
  return {
    type: SET_CLIENT_SESSION_STATE,
    sessionState,
  }
}

export function setClientSessionLastActivity(lastActivityTimeStamp) {
  return {
    type: SET_CLIENT_SESSION_LAST_ACTIVITY,
    lastActivityTimeStamp,
  }
}

export const setQuoteJourneyPosition = (journeyPosition) => ({
  type: SET_QUOTE_JOURNEY_POSITION,
  journeyPosition,
})

export const requestConfusedQuickQuote = () => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE,
})

export const requestConfusedQuickQuoteSuccess = (status) => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE_SUCCESS,
  status,
})

export const requestConfusedQuickQuoteFailure = () => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE_FAILURE,
})

export const requestConfusedQuickQuoteResponse = () => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE,
})

export const requestConfusedQuickQuoteResponseSuccess = (quickQuote) => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE_SUCCESS,
  quickQuote,
})

export const requestConfusedQuickQuoteResponseFailure = () => ({
  type: REQUEST_CONFUSED_QUICK_QUOTE_RESPONSE_FAILURE,
})

export function requestConfusedExternalAccount(authToken){
  return {
    type: REQUEST_CONFUSED_EXTERNAL_ACCOUNT,
    authToken
  }
}

export function requestConfusedExternalAccountSuccess(data){
  return {
    type: REQUEST_CONFUSED_EXTERNAL_ACCOUNT_SUCCESS,
    data
  }
}

export function requestConfusedExternalAccountFailure(){
  return {
    type: REQUEST_CONFUSED_EXTERNAL_ACCOUNT_FAILURE,
  }
}

export function updateConfusedExternalAccount(data){
  return {
    type: UPDATE_CONFUSED_EXTERNAL_ACCOUNT,
    data
  }
}
